import { Box, Grid } from "@mui/material";
import MKBox from "components/MKBox";
import CenteredFooter from "layouts/components/Footers/CenteredFooter";
// import logoTelkom from "assets/images/logos/logo-telkom.png";
import lockedIllust from "assets/images/illustrations/locked-illustration.png";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import { Download } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const SebNotif = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ flexGrow: 1 }} margin={0} padding={0}>
      <Grid container spacing={0} margin={0} padding={0} sx={{ height: "100vh" }}>
        <Grid
          item
          xs={12}
          margin={0}
          padding={0}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <Box
            sx={{
              background: "#FAFAFA",
              width: 1,
              height: 80,
              alignItems: "center",
              display: "flex",
              padding: 0,
              boxShadow: "0px 1px 1px rgba(66, 66, 66, 0.2), 0px 0px 2px rgba(66, 66, 66, 0.2)",
            }}
          >
            <Grid container spacing={0} margin={0} padding={0}>
              <Grid item xs={3.5} display="flex" justifyContent="center" alignItems="center">
                {/* <img
                  src={logoTelkom}
                  alt="Logo Telkom"
                  style={{
                    height: "48px",
                    marginRight: "16px",
                  }}
                /> */}
              </Grid>
              <Grid item xs={8.5} />
            </Grid>
          </Box>
        </Grid>

        <Grid container display="flex" justifyContent="center" alignItems="center">
          <MKBox
            sx={{
              backgroundColor: "#E6FFFA",
              width: "80%",
              padding: 3,
              borderRadius: 3,
              border: `2px solid #38B2AC`,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src={lockedIllust} width="239px" height="239p" alt="Locked SEB" />
            <MKTypography
              sx={{
                fontSize: "24px",
                fontWeight: "bold",
                textAlign: "center",
                whiteSpace: "break-spaces",
              }}
            >
              {
                "To ensure a secure exam environment, please download the Safe Exam Browser.\nIf you have not downloaded it yet, please proceed with the download.\nIf already installed, access the exam domain or website using the Safe Exam Browser application for a secure experience."
              }
            </MKTypography>
            <MKButton
              color="success"
              sx={{ my: 2 }}
              onClick={() => navigate("/downloadSeb")}
              startIcon={<Download />}
            >
              Download Exam Browser & Config SEB
            </MKButton>
          </MKBox>
        </Grid>

        <Grid item xs={12} marginTop={4} display="flex" alignItems="flex-end">
          <MKBox mt="auto" sx={{ width: "100%" }}>
            <CenteredFooter light />
          </MKBox>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SebNotif;
